import apiClient from './api.service';
import {
  SurveyInvitation,
  InvitationStats,
  BulkInviteResult,
  DeliveryStatus,
} from '../types/invitation.types';

// Phase 5 - US3: Invitation Service (T096)

export const invitationService = {
  async uploadCSVAndInvite(surveyId: string, file: File): Promise<BulkInviteResult> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(
      `/api/surveys/${surveyId}/invitations`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data.data;
  },

  async listInvitations(
    surveyId: string,
    params?: {
      deliveryStatus?: DeliveryStatus;
      page?: number;
      limit?: number;
    }
  ): Promise<{
    invitations: SurveyInvitation[];
    total: number;
    page: number;
    limit: number;
  }> {
    const response = await apiClient.get(`/api/surveys/${surveyId}/invitations`, {
      params,
    });
    return response.data.data;
  },

  async getStats(surveyId: string): Promise<InvitationStats> {
    const response = await apiClient.get(`/api/surveys/${surveyId}/invitations/stats`);
    return response.data.data;
  },
};

export default invitationService;
